/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Features_Note_3_DescriptionInputs */

const en_homepage_features_note_3_description = /** @type {(inputs: Homepage_Features_Note_3_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-timestamped. Synced on all devices. No need to dig through notebooks or get lost in Google docs`)
};

const es_homepage_features_note_3_description = /** @type {(inputs: Homepage_Features_Note_3_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con marca de tiempo automática. Sincronizadas en todos los dispositivos. Sin necesidad de buscar en cuadernos o perderse en Google Docs`)
};

/**
* | output |
* | --- |
* | "Auto-timestamped. Synced on all devices. No need to dig through notebooks or get lost in Google docs" |
*
* @param {Homepage_Features_Note_3_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_features_note_3_description = /** @type {((inputs?: Homepage_Features_Note_3_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Features_Note_3_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_features_note_3_description(inputs)
	return en_homepage_features_note_3_description(inputs)
});